import { BrowserModule, Title } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Injectable } from '@angular/core';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { ConfigComponent } from './widgets/config/config.component';
import { EnabledNodesPipe } from './pipes/enabled-nodes.pipe';
import { FooterComponent } from './widgets/footer/footer.component';
import { HeaderComponent } from './widgets/header/header.component';
//import { StatusbarComponent } from './widgets/simulator/menu/statusbar/statusbar.component';
import { SimulatorComponent } from './widgets/simulator/simulator.component';
import { ScreenComponent } from './widgets/simulator/screen/screen.component';
//import { DefaultscreenComponent } from './widgets/simulator/screen/defaultscreen/defaultscreen.component';
import { DebugcontrolsComponent } from './widgets/debug/debugcontrols/debugcontrols.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { PwaInstallerComponent } from './widgets/pwa-installer/pwa-installer.component';
import { MenuIndicatorComponent } from './widgets/basic/menu-indicator/menu-indicator.component';
import { IconBarComponent } from './widgets/basic/icon-bar/icon-bar.component';
import { BaseDisplayComponent } from './widgets/basic/base-display/base-display.component';
import { ScaleComponent } from './widgets/basic/scale/scale.component';
import { IdleComponent } from './widgets/basic/idle/idle.component';
import { DashComponent } from './widgets/basic/dash/dash.component';
import { SettingsvalueComponent } from './widgets/basic/settingsvalue/settingsvalue.component';
import { WaterpressureComponent } from './widgets/basic/waterpressure/waterpressure.component';
import { ContactInfoComponent } from './widgets/basic/contact-info/contact-info.component';
import { LockWidgetComponent } from './widgets/basic/lock-widget/lock-widget.component';
import { LoadinganimationComponent } from './widgets/basic/loadinganimation/loadinganimation.component';
import { MenuComponent } from './widgets/basic/menu/menu.component';
import { ToastComponent } from './widgets/basic/toast/toast.component';
import { CodeabfrageComponent } from './widgets/basic/fachhandwerker/codeabfrage/codeabfrage.component';
import { EnergiedatenComponent } from './widgets/basic/fachhandwerker/energiedaten/energiedaten.component';
import { InlineMenuComponent } from './widgets/basic/inline-menu/inline-menu.component';
import { ScaleListComponent } from './widgets/basic/scale-list/scale-list.component';
import { SetPhoneComponent } from './widgets/basic/set-phone/set-phone.component';
import { EcoComponent } from './widgets/basic/eco/eco.component';
import { TimesetComponent } from './widgets/basic/timeset/timeset.component';
import { SetupComponent } from './widgets/basic/setup/setup.component';
import { ZeitprogrammComponent } from './widgets/basic/zeitprogramm/zeitprogramm.component';
import { QuickvetoComponent } from './widgets/basic/quickveto/quickveto.component';

@Injectable()
export class MyHammerConfig extends HammerGestureConfig  {
  overrides = <any>{
    'swipe': {velocity: 0.4, threshold: 20}, // override default settings
    'pan': {velocity: 0.5, threshold: 1} // override default settings
  }
}
@NgModule({
  declarations: [
    AppComponent,
    ConfigComponent,
    FooterComponent,
    PwaInstallerComponent,
    HeaderComponent,
    SimulatorComponent,
    ScreenComponent,
    DebugcontrolsComponent,
    MenuIndicatorComponent,
    IconBarComponent,
    BaseDisplayComponent,
    ScaleComponent,
    IdleComponent,
    DashComponent,
    SettingsvalueComponent,
    WaterpressureComponent,
    ContactInfoComponent,
    LockWidgetComponent,
    LoadinganimationComponent,
    MenuComponent,
    EnabledNodesPipe,
    ToastComponent,
    CodeabfrageComponent,
    EnergiedatenComponent,
    InlineMenuComponent,
    ScaleListComponent,
    SetPhoneComponent,
    EcoComponent,
    TimesetComponent,
    SetupComponent,
    ZeitprogrammComponent,
    QuickvetoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
  ],
  entryComponents:[
    BaseDisplayComponent,
    DashComponent,
    IdleComponent,
    SettingsvalueComponent,
    WaterpressureComponent,
    ContactInfoComponent,
    LockWidgetComponent,
    LoadinganimationComponent,
    MenuComponent,
    ToastComponent,
    CodeabfrageComponent,
    EnergiedatenComponent,
    InlineMenuComponent,
    ScaleListComponent,
    SetPhoneComponent,
    EcoComponent,
    TimesetComponent,
    SetupComponent,
    ZeitprogrammComponent,
    QuickvetoComponent
  ],
  providers: [
      EnabledNodesPipe,
      {
          provide: HAMMER_GESTURE_CONFIG, 
          useClass: MyHammerConfig 
      }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
